export default __webpack_public_path__ + "static/media/check_red.a346b9d9.svg";